import { render } from "./MtpLaunchBanner.vue?vue&type=template&id=0f4cd45c"
import script from "./MtpLaunchBanner.vue?vue&type=script&lang=js"
export * from "./MtpLaunchBanner.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__